import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AccountResourceService } from './api/accountResource.service';
import { ActionResourceService } from './api/actionResource.service';
import { AthleteResourceService } from './api/athleteResource.service';
import { BannerResourceService } from './api/bannerResource.service';
import { BuyControllerService } from './api/buyController.service';
import { ClientInfoResourceService } from './api/clientInfoResource.service';
import { EventResourceService } from './api/eventResource.service';
import { FileResourceService } from './api/fileResource.service';
import { NewsResourceService } from './api/newsResource.service';
import { PublicUserResourceService } from './api/publicUserResource.service';
import { ResourceResourceService } from './api/resourceResource.service';
import { RoleResourceService } from './api/roleResource.service';
import { SportResourceService } from './api/sportResource.service';
import { TransactionResourceService } from './api/transactionResource.service';
import { UserJwtControllerService } from './api/userJwtController.service';
import { UserProfileResourceService } from './api/userProfileResource.service';
import { UserResourceService } from './api/userResource.service';
import { UserUploadHistoryResourceService } from './api/userUploadHistoryResource.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
